import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Alert } from 'react-bootstrap';
import PageTitle from '../../components/PageTitle'
import Table from '../../components/Table';
import FeatherIcon from 'feather-icons-react';
import Popup from '../../components/Popup';

const API = process.env.REACT_APP_CLIENT_IP;

function VouchersTaken() {
    const [data, setData] = useState([]);
    const [inputData, setInputData] = useState({})
    const [notify, setNotify] = useState({ show: false, variant: '', message: '' })

    const [showPop, setShowPop] = useState({ show: false, dataId: '' })

    const columns = [
        {
            Header: 'Customer Name',
            accessor: 'customerName',
            sort: true,
        },
        {
            Header: 'Telephone',
            accessor: 'phoneNumber',
            sort: true
        },
        {
            Header: 'Voucher Taken',
            accessor: 'voucher',
            sort: true,
        },
        {
            Header: 'Date Taken',
            accessor: 'dateTaken',
            /* Cell: (cell) => {
                let { original } = cell.cell.row;
                let dateTaken = moment(original.createdAt).format("dddd, MMMM Do YYYY, h:mm:ss a");
                return dateTaken;
            }, */
            sort: true,
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: (cell) => {
                let { original } = cell.cell.row;
                return <div style={{ display: 'flex', flexDirection: 'row', border: 'none', alignItems: 'center' }}>
                    <FeatherIcon onClick={() => {
                        setShowPop({ show: true }); setInputData(original)
                    }} style={{ marginLeft: '3px', cursor: 'pointer' }} className="icon-dual-danger" icon="trash-2" />

                </div>
            }
        }
    ];

    const sizePerPageList = [
        {
            text: '5',
            value: 5,
        },
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: 'All',
            value: data.length,
        },
    ];

    const fetchRecords = async () => {
        let res = await fetch(`${API}/api/customervoucher/list`).then(response => response.json());
        if (res.success) {
            setData(res.data);
            console.log(res.data);
        }
    }

    const onDelete = async (id, voucher) => {
        try {
            let res = await fetch(`${API}/api/customervoucher/${id}/${voucher}`, {
                method: 'DELETE'
            }).then(response => response.json());
            if (res.success) {
                fetchRecords();
                setInputData({});
                setShowPop({ show: false, dataId: '' })
                setNotify({
                    show: true,
                    message: "Deleted Successfully!",
                    variant: "success",
                });
                setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
            } else {
                setNotify({
                    show: true,
                    message: `${res.data.error.msg}`,
                    variant: "danger",
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => { fetchRecords(); }, [])
    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Home', path: '/customervoucherlist' },
                    { label: 'Customer Vouchers Taken', path: '/customervoucherlist', active: true },
                ]}
                title={'Customer Vouchers Taken'}
            />
            <Popup show={showPop.show}
                handleClose={() => setShowPop({ show: false })}
                handleDelete={() => onDelete(inputData.customerId, inputData.voucher)}
            />
            <Alert show={notify.show} variant={notify.variant} >{notify.message}</Alert>

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col xs={8}>
                                    <h4 className="header-title">Customers and Vouchers Taken </h4>
                                    <p className="text-muted fs-14 mb-4">List of Customers and Vouchers Taken</p>
                                </Col>
                            </Row>

                            <Table
                                columns={columns}
                                data={data}
                                pageSize={5}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                isSearchable={true}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default VouchersTaken